import { VehiclesImportResponse } from '../../models/vehicles-import-response';
import { VehiclesInvalidRecord } from '../../models/vehicles-invalid-record';

export function catalogVehiclesImportResponse(
  validationResult: string,
  importResult: string,
  vehicleId: string,
  data: Record<string, unknown>,
  importResponse: VehiclesImportResponse
) {
  switch (validationResult) {
    case 'DuplicateVehicleId':
    case 'DuplicateVehicleIdInPartner':
    case 'EmptyVehicleId':
    case 'OverCharLimitVehicleId':
      importResponse.invalid.push(
        new VehiclesInvalidRecord(vehicleId, 'invalid-id', data)
      );
      break;
    case 'DuplicateVehicleName':
    case 'EmptyVehicleName':
    case 'OverCharLimitVehicleName':
      importResponse.invalid.push(
        new VehiclesInvalidRecord(vehicleId, 'invalid-name', data)
      );
      break;
    case 'OK':
      importResponse.imported += 1;
      if (importResult === 'Inserted') {
        importResponse.importInserted += 1;
      } else {
        importResponse.importUpdated += 1;
      }
      break;
    default:
      importResponse.unrecoverable += 1;
      break;
  }
}
